import { Dialog } from '@mui/material';
import { BaseDialogProps } from './BaseDialog.types';

/**
 * BaseDialog component that wraps the MUI Dialog component.
 *
 * @param classes - {@link BaseDialogProps.classes classes} description.
 * @param ariaLabel - {@link BaseDialogProps.ariaLabel ariaLabel} description.
 * @param ariaDescribedBy - {@link BaseDialogProps.ariaDescribedBy ariaDescribedBy} description.
 * @param ariaLabelledBy - {@link BaseDialogProps.ariaLabelledBy ariaLabelledBy} description.
 * @param open - {@link BaseDialogProps.open open} description.
 * @param onClose - {@link BaseDialogProps.onClose onClose} description.
 * @param children - {@link BaseDialogProps.children children} description.
 */
export const BaseDialog = ({
    classes,
    ariaLabel,
    ariaDescribedBy,
    ariaLabelledBy,
    open,
    onClose,
    hideBackdrop,
    children,
}: BaseDialogProps) => {
    return (
        <Dialog
            classes={{
                ...classes,
            }}
            aria-label={ariaLabel}
            aria-describedby={ariaDescribedBy}
            aria-labelledby={ariaLabelledBy}
            aria-modal={true}
            open={open}
            onClose={onClose}
            hideBackdrop={hideBackdrop}
        >
            {children}
        </Dialog>
    );
};